<button class="btn btn-primary" (click)="handleGoogleLogin()">Connect</button>